import React from "react";
import type { GroupBase } from "react-select";

import cx from "classnames";

import Selector, {
	components,
	type ControlProps,
	type SelectorOption,
	type SelectorProps,
	type ValueContainerProps,
} from "~/ui/selectors/Selector";

import styles from "./IndicatorlessSelector.module.css";

function Control<Option extends SelectorOption, IsMulti extends boolean, Group extends GroupBase<Option>>({
	children,
	className,
	...rest
}: ControlProps<Option, IsMulti, Group>) {
	return (
		<components.Control<Option, IsMulti, Group> {...rest} className={cx(className, styles.control)}>
			{children}
		</components.Control>
	);
}

function ValueContainer<Option extends SelectorOption, IsMulti extends boolean, Group extends GroupBase<Option>>({
	children,
	className,
	...rest
}: ValueContainerProps<Option, IsMulti, Group>) {
	return (
		<components.ValueContainer<Option, IsMulti, Group> {...rest} className={cx(className, styles.valueContainer)}>
			{children}
		</components.ValueContainer>
	);
}

function NullComponent() {
	return null;
}

function IndicatorlessSelector<T extends SelectorOption>({ components: componentsProp, ...props }: SelectorProps<T>) {
	return (
		<Selector<T>
			condensed
			components={{
				DropdownIndicator: NullComponent,
				Control,
				ValueContainer,
				...componentsProp,
			}}
			styles={{
				singleValue: (base, state) => ({
					...base,
					color: `var(--${state.isDisabled ? "placeholderTextColor" : "primaryTextColor"})`,
				}),
			}}
			{...props}
		/>
	);
}

export default IndicatorlessSelector;
